import { useEffect, useState } from 'react';

export function useNylIdleTimeoutEditor(effectiveValue: number) {
  const [draftValue, setDraftValue] = useState(String(effectiveValue));
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!isEditing) {
      setDraftValue(String(effectiveValue));
    }
  }, [effectiveValue, isEditing]);

  return {
    draftValue,
    isEditing,
    setDraftValue,
    startEditing: (value: number) => {
      setDraftValue(String(value));
      setIsEditing(true);
    },
    stopEditing: () => setIsEditing(false),
    cancelEditing: () => {
      setDraftValue(String(effectiveValue));
      setIsEditing(false);
    },
  };
}
